// extracted by mini-css-extract-plugin
module.exports = {"Marker":"VideoComment_Marker__QYO07","Icon":"VideoComment_Icon__GStJg"};